"use strict";

import React from 'react';

import { _I_, defineSimpleTerm } from 'components/locs';
import { BootButton, CloseButton } from 'generics/buttons';
import { IconGlyphicon, IconFontAwesome } from 'generics/icons';

import MoneyUtil from 'components/moneyUtil';
import G_marketConfigStorage from 'components/globalMarketConfigStorage';


export default class ViewItemBuyEditor extends React.Component {
  constructor(props)  {
    super(props);

    const initialPrice = MoneyUtil.parseMoney( this.props.initialPrice );
    const buyPrice =  ( isFinite(initialPrice) && (initialPrice > 0) )  ?  initialPrice  :  10000;
    const priceText = MoneyUtil.formatMoney(buyPrice);

    const userCurrStr = MoneyUtil.formatCurr(  SettingsInjections.getUsedCurrency().market  );
    const buyPriceMin = G_marketConfigStorage.getPriceMin();
    const buyPriceMax = G_marketConfigStorage.getPriceMax();
    this.currentLocale = SettingsInjections.getUsedLocale();

    this.state = {
      buyPrice,
      priceText,

      buyAmount: 1,
      amountText: "",

      buyPriceMin,
      buyPriceMax,
      agree: false,
      userCurrStr,
    }
  }


  handleAgreeClick = ( event )  =>  {
    const agree =  this.state.agree ? false : Date.now();
    this.setState({  agree });
  }


  handleAmountBlur = ( e )  =>  {
    const amountText =  `${this.state.buyAmount}`
    if (amountText == this.state.amountText)  {
      return;
    }

    this.setState({ amountText });
  }


  handleAmountWheel = ( e )  =>  {
    e.preventDefault();

    const delta = Math.sign( e.deltaY )*(e.ctrlKey? 10 : 1);
    const newValue = this.state.buyAmount - delta;

    this.processAmountChange((newValue > 0) ? newValue : 0);
  }


  handleAmountChange = ( event )  =>  {
    this.processAmountChange(event.target.value);
  }


  processAmountChange( val )  {
    const [ , amountText ] = (/^\s*([0-9]+)\s*$/).exec( val )||[];
    if ( !amountText )  {
      this.setState({ amountText: "" });
    }

    if (amountText == this.state.amountText)  {
      return;
    }

    const buyAmount = +amountText;
    if ( buyAmount > 0 )  {
      this.setState({ buyAmount, amountText });
    }
  }


  handleBlurPrice = ( e )  =>  {
    const priceText =  MoneyUtil.formatMoney( this.state.buyPrice );

    if (priceText != this.state.priceText)  {
      this.setState({ priceText });
    }
  }


  handlePriceWheel = ( e )  =>  {
    e.preventDefault();

    const delta = 10000*Math.sign( e.deltaY )*(e.ctrlKey? 10 : (e.shiftKey ? 0.1 : 1));
    const newValue = MoneyUtil.formatMoney( this.state.buyPrice - delta );

    if ( +newValue >= 0 )  {
      this.processPriceChange( newValue );
    }
  }


  handlePriceChange = ( event )  =>  {
    this.processPriceChange(event.target.value);
  }


  processPriceChange( val )  {
    const [ , hi, dot, lo ] = ((/^\s*(\d*)(?:(\.)(\d*))?\s*$/).exec( val ) || []);
    if ( (!hi) && (!lo) )
      return;

    const priceText = `${hi||""}${dot&&"."||""}${lo||""}`;
    if ( this.state.priceText === priceText  )
      return;

    const buyPrice = MoneyUtil.parseMoney( val );
    if ( isFinite(buyPrice) && ( buyPrice >= 0 ) )  {
        this.setState({ buyPrice, priceText });
    }
  }


  getResult()  {
    const {  buyAmount, buyPrice, buyPriceMin, buyPriceMax,  userCurrStr,  agree, amountText  } = this.state;

    const notes = [];
    let isValid = true;
    let amount = Math.floor( buyAmount );
    if ( isFinite( amount ) )  {
      if ( amount < 1 || !amountText )  {
        isValid = false;
        amount = NaN;
        notes.push(_I_("ItemBuyEditor.note.posAmount"));

      }  else  if ( amount > 1000 )  {
        isValid = false;
        amount = NaN;
        notes.push(_I_("ItemBuyEditor.note.maxAmount"));
      }

    }  else  {
      isValid = false;
      amount = NaN;
      notes.push(_I_("ItemBuyEditor.note.invalidAmount"));
    }

    let price = Math.floor( buyPrice );
    if ( isFinite(  price ) )  {
      if ( price < buyPriceMin )  {
        isValid = false;
        price = NaN;
        notes.push(`${_I_("ItemBuyEditor.note.minPrice")} ${MoneyUtil.formatMoney(buyPriceMin)} ${userCurrStr}`);
      }  else  {
        const total = (amount*price);
        if ( total > buyPriceMax )  {
          isValid = false;
          price = NaN;
          notes.push(`${_I_("ItemBuyEditor.note.maxTotal")} ${MoneyUtil.formatMoney(buyPriceMax)} ${userCurrStr}` );
        }
      }

    }  else  {
      isValid = false;
      price = NaN;
      notes.push(_I_("ItemBuyEditor.note.invalidPrice"));

    }


    return { isValid, amount, price, agree, notes };
  }


  renderBuyButton( isValid, notes, requiredFunds ) {

    if ( requiredFunds )  {
      const {  userCurrStr  } = this.state;
      const handler = () => document.location.assign("https://store.gaijin.net/balance.php");

      return (<BootButton variant="warning" disabled={ !isValid } block
                    onClick={handler}
                    title={notes.join("\n")}
                    >
                  <IconFontAwesome type="coin" />&nbsp;
                  {_I_("ItemBuyEditor.label.buyCouns")} {requiredFunds} {userCurrStr}
              </BootButton>);
    }

    const disabled = !(  isValid  &&  this.state.agree  );
    return (<BootButton variant={disabled ? "primary": "success"} disabled={disabled} block
                  onClick={this.props.processBuyOrder}
                  title={notes.join("\n")}
                  >
                <IconFontAwesome type="check" />&nbsp;{_I_("ItemBuyEditor.label.submit")}
            </BootButton>);
  }


  render() {
    const { isValid, amount, price, notes, agree }  =  this.getResult();
    const total = amount*price;
    const requiredFunds = Math.ceil( Math.max( total - (this.props.balance.gjn||0),  0 )/10000 );
    const { priceText, amountText } = this.state;

    if ( isValid )  {
      if ( requiredFunds )
        notes.push(`${_I_("ItemBuyEditor.note.insufficentFunds0")} ${this.state.userCurrStr} ${_I_("ItemBuyEditor.note.insufficentFunds1")}`);

      if ( !agree )
        notes.push(_I_("ItemBuyEditor.note.mustAgree"));
    }

    const danger = isValid ? null : (<span className="label label-danger" title={notes.join("\n")}>
                                        <IconGlyphicon type="exclamation-sign" />
                                      </span>);
    let termsUrl = "https://gaijin.net/"+this.currentLocale.icon+"/termsofservice";

    return (
        <div className="view-trade-editor">
          <div className="editor-row">
            <span className="label-column">{_I_("ItemBuyEditor.label.price")}</span>
            <span className="icon-column">{danger}</span>
            <span className="input-column" onWheel={this.handlePriceWheel}
                  title={_I_("ItemBuyEditor.label.wheelInput")}  >
              <input type="text" className="form-control input-sm"
                     value={priceText}
                     onBlur={this.handleBlurPrice}
                     onChange={this.handlePriceChange} />
            </span>
          </div>

          <div className="editor-row">
            <span className="label-column">{_I_("ItemBuyEditor.label.amount")}</span>
            <span className="icon-column">{danger}</span>
            <span className="input-column" onWheel={this.handleAmountWheel}
                  title={_I_("ItemBuyEditor.label.wheelAmountInput")}  >
              <input type="text" className="form-control input-sm"
                     value={amountText}
                     onBlur={this.handleAmountBlur}
                     onChange={this.handleAmountChange} />
            </span>
          </div>

          <div className="editor-row">
            <span className="label-column">{_I_("ItemBuyEditor.label.totalPrice")}{amountText}</span>
            <span className="icon-column">{danger}</span>
            <span className="input-column text-center">
              <input type="text" className="form-control input-sm" readOnly
                     value={MoneyUtil.formatMoney(total)} />
            </span>
          </div>

            <div className="editor-row">
              <span className="label-column fixup-height-for-button">
                <span  className="agree-checkbox"  onClick={this.handleAgreeClick}  >
                  <IconGlyphicon type={agree ? "check" : "unchecked"} />&nbsp;
                  {_I_("ItemBuyEditor.label.agree")}
                </span>&nbsp;
                <a    href={termsUrl}
                      target="_blank"
                      rel="noopener noreferrer"  >
                  {_I_("ItemBuyEditor.label.ToU")}&nbsp;<IconGlyphicon type="share" /></a>
              </span>
              <span className="icon-column">&nbsp;</span>
              <span className="input-column">{this.renderBuyButton( isValid, notes, requiredFunds )}
              </span>
            </div>
        </div>
      );
  }
}


defineSimpleTerm( "ItemBuyEditor.label.wheelAmountInput",  "You can use mouse wheel to spin amount,\nctrl+wheel = 10x speed",       {
  "ru_RU": "Можно использовать колесо прокрутки для изменения,\nctrl+колесо = 10x скорость",
  "cs_CZ": "You can use mouse wheel to spin amount,\nctrl+wheel = 10x speed",
  "fr_FR": "Vous pouvez utiliser la roulette de votre souris pour faire défiler,\nctrl+roulette = vitesse x10",
  "de_DE": "Du kannst das Mausrad benutzen um die Anzahl zu ändern,\nstrg+Mausrad = Geschwindigkeit x10",
  "it_IT": "Puoi usare la rotella del mouse per aumentare il quantitativo,\nctrl+rotella = velocità 10x",
  "ko_KR": "마우스 휠을 이용하여 구매 수량을 결정할 수 있습니다, \nCtrl+휠키로 10개 씩 구매할 수 있습니다.",
  "pl_PL": "Możesz użyć kółka myszy do regulacji liczby,\nctrl+kółko = prędkość 10x",
  "pt_PT": "You can use mouse wheel to spin amount,\nctrl+wheel = 10x speed",
  "es_ES": "Puede usar la rueda del mouse para girar la cantidad,\nctrl + rueda = 10x velocidad",
  "zh_CN": "你可以使用鼠标滚轮转动数量，\nctrl+滚轮 = 10 倍速度",
  "zh_TW": "你可以使用滑鼠滾輪調動數量，\n ctrl+滾輪 = 10 倍速度"
} );


defineSimpleTerm( "ItemBuyEditor.label.wheelInput",  "You can use mouse wheel to spin price,\nctrl+wheel = 10x speed,\nshift+wheel=0.1x speed",       {
  "ru_RU": "Можно использовать колесо прокрутки для изменения,\nctrl+колесо = 10x скорость,\nshift+колесо=0.1x скорость",
  "cs_CZ": "You can use mouse wheel to spin price,\nctrl+wheel = 10x speed,\nshift+wheel=0.1x speed",
  "fr_FR": "Vous pouvez utiliser la roulette de votre souris pour faire défiler,\nctrl+roulette = vitesse x10,\nshift+roulette=vitesse x0.1",
  "de_DE": "Du kannst das Mausrad benutzen um den Preis zu ändern,\nstrg+Mausrad = Geschwindigkeit x10,\nshift+Mausrad = Geschwindigkeit x0,1",
  "it_IT": "Puoi utilizzare la rotella del mouse per aumentare il prezzo,\nctrl+rotella = velocità 10x,\nshift+rotella=velocità 0.1x",
  "ko_KR": "마우스 휠키를 이용하여 구매 가격을 결정할 수 있습니다, \nCtrl+휠키로 10단위의 가격을, \nShift+휠키로 0.1단위의 가격을 설정할 수 있습니다.",
  "pl_PL": "Możesz użyć kółka myszy do regulacji ceny,\nctrl+kółko = prędkość 10x\nshift+kółko=prędkość 0.1x",
  "pt_PT": "You can use mouse wheel to spin price,\nctrl+wheel = 10x speed,\nshift+wheel=0.1x speed",
  "es_ES": "Puede usar la rueda del mouse para girar el precio,\nctrl + rueda = 10x speed,\nshift + rueda = 0.1x velocidad",
  "zh_CN": "你可以使用鼠标滚轮转动价格，\nctrl+滚轮 = 10 倍速度，\nshift+滚轮 = 0.1 倍速度",
  "zh_TW": "你可以使用滑鼠滾輪調動價格，\n ctrl+滾輪 = 10 倍速度，\n shift+滾輪 = 0.1 倍速度"
} );


defineSimpleTerm( "ItemBuyEditor.note.posAmount",  "Amount value should be positive",       {
  "ru_RU": "Количество должно быть положительным",
  "cs_CZ": "Hodnota množství by měla být plusová",
  "fr_FR": "Le montant doit être positif",
  "de_DE": "Der Wert sollte positiv sein",
  "it_IT": "L'ammontare deve essere positivo",
  "ko_KR": "최종 결정가는 0보다 적을 수 없습니다.",
  "pl_PL": "Ilość powinna być wartością dodatnią",
  "pt_PT": "Amount value should be positive",
  "es_ES": "El valor de importe debe ser positivo",
  "zh_CN": "数量应为正数",
  "zh_TW": "數量應為正數"
} );


defineSimpleTerm( "ItemBuyEditor.note.maxAmount",  "Amount value is over maximum on 1000 items",       {
  "ru_RU": "Количество не должно превосходить 1000",
  "cs_CZ": "Hodnota množství překračuje 1000 předmětů",
  "fr_FR": "Le montant est supérieur au maximum de 1000 items",
  "de_DE": "Der Wert ist über dem Maximum von 1000 Items",
  "it_IT": "Il valore è oltre il massimo di 1000 oggetti",
  "ko_KR": "최종 결정량은 1000개를 넘을 수 없습니다",
  "pl_PL": "Wartość przekracza maksimum na 1000 przedmiotów",
  "pt_PT": "Amount value is over maximum on 1000 items",
  "es_ES": "El valor del importe supera el máximo en 1000 artículos",
  "zh_CN": "数量超过 1000 个物品的上限",
  "zh_TW": "數量超過 1000 個物品的上限"
} );


defineSimpleTerm( "ItemBuyEditor.note.invalidAmount",  "Invalid amount value",       {
  "ru_RU": "Количество должно быть целым положительным числом",
  "cs_CZ": "Nekorektní množství",
  "fr_FR": "Valeur de montant invalide",
  "de_DE": "Unzulässiger Wert",
  "it_IT": "Valore quantitativo invalido",
  "ko_KR": "적절하지 않은 결정값입니다",
  "pl_PL": "Nieprawidłowa ilość",
  "pt_PT": "Invalid amount value",
  "es_ES": "Valor de la cantidad no válida",
  "zh_CN": "数量值无效",
  "zh_TW": "數量值無效"
} );


defineSimpleTerm( "ItemBuyEditor.note.minPrice",  "The minimum price is",       {
  "ru_RU": "Минимальная цена",
  "cs_CZ": "Minimální cena je",
  "fr_FR": "Le prix minimum est",
  "de_DE": "Der minimale Preis ist",
  "it_IT": "Il prezzo minimo è",
  "ko_KR": "최소 가격은 다음과 같습니다",
  "pl_PL": "Minimalna cena to",
  "pt_PT": "The minimum price is",
  "es_ES": "El precio minimo es",
  "zh_CN": "最低价格为",
  "zh_TW": "最低價格為"
} );


defineSimpleTerm( "ItemBuyEditor.note.maxTotal",  "Order totals is over maximum of",       {
  "ru_RU": "Максимальная сумма превышает",
  "cs_CZ": "Celková hodnota příkazů překračuje",
  "fr_FR": "Le total des commandes est supérieur au maximum de",
  "de_DE": "Die Auftragsanzahl ist über dem Maximum von",
  "it_IT": "Gli ordini totali sono oltre il massimo di",
  "ko_KR": "최종 구매 수량은 다음과 같습니다",
  "pl_PL": "Zamówienie całkowite przekracza maksimum",
  "pt_PT": "Order totals is over maximum of",
  "es_ES": "El total de pedidos supera el máximo de",
  "zh_CN": "订单总数超过最大值",
  "zh_TW": "訂單總數超過最大值"
} );


defineSimpleTerm( "ItemBuyEditor.note.invalidPrice",  "Invalid price value",       {
  "ru_RU": "Цена должна быть положительным числом",
  "cs_CZ": "Nekorektní cena",
  "fr_FR": "Valeur de prix invalide",
  "de_DE": "Unzulässiger Wert",
  "it_IT": "Prezzo non valido",
  "ko_KR": "적절하지 않은 구매 가격입니다",
  "pl_PL": "Nieprawidłowa cena",
  "pt_PT": "Invalid price value",
  "es_ES": "Valor de precio inválido",
  "zh_CN": "价格值无效",
  "zh_TW": "價格值無效"
} );


defineSimpleTerm( "ItemBuyEditor.note.mustAgree",  "Must agree to Terms Of Use",       {
  "ru_RU": "Необходимо принять Пользовательское соглашение",
  "cs_CZ": "Nutno souhlasit s Podmínkami užití",
  "fr_FR": "Vous devez accepter les conditions d'utilisation",
  "de_DE": "Du musst den Nutzungsbedingungen zustimmen",
  "it_IT": "Devi accettare i Termini di Utilizzo",
  "ko_KR": "이용 약관에 동의해 주셔야 합니다",
  "pl_PL": "Należy zaakceptować umowę Terms Of Use",
  "pt_PT": "Must agree to Terms Of Use",
  "es_ES": "Debe aceptar los Términos de uso",
  "zh_CN": "必须同意使用条款",
  "zh_TW": "必須同意使用條款"
} );


defineSimpleTerm( "ItemBuyEditor.note.insufficentFunds0",  "Insufficent funds, you need more",       {
  "ru_RU": "На балансе недостаточно",
  "cs_CZ": "Nedostatek prostředků, potřebujete víc",
  "fr_FR": "Fonds insuffisants, vous avez besoin de plus",
  "de_DE": "Ungenügend Geldmittel, du brauchst mehr",
  "it_IT": "Fondi insufficienti, ne servono di più",
  "ko_KR": "가이진 코인이 부족합니다, 다음의 가이진 코인이",
  "pl_PL": "Za mało funduszy, potrzebujesz więcej",
  "pt_PT": "Insufficent funds, you need more",
  "es_ES": "Fondos insuficientes, necesitas más",
  "zh_CN": "资金不足，你需要更多资金",
  "zh_TW": "餘額不足，你需要更多Gaijin幣"
} );


defineSimpleTerm( "ItemBuyEditor.note.insufficentFunds1",  "for this order",       {
  "ru_RU": "для этого заказа",
  "cs_CZ": "na tento příkaz",
  "fr_FR": "pour cette commande",
  "de_DE": "für diesen Auftrag",
  "it_IT": "per questo ordine",
  "ko_KR": "이 아이템 구매를 위해 필요합니다",
  "pl_PL": "dla tego polecenia",
  "pt_PT": "for this order",
  "es_ES": "para esta orden",
  "zh_CN": "才能操作此订单",
  "zh_TW": "才能操作此訂單"
} );


defineSimpleTerm( "ItemBuyEditor.label.buyCouns",  "Buy",       {
  "ru_RU": "Купить",
  "cs_CZ": "Koupit",
  "fr_FR": "Acheter",
  "de_DE": "Kaufen",
  "it_IT": "Compra",
  "ko_KR": "구매",
  "pl_PL": "Kup",
  "pt_PT": "Buy",
  "es_ES": "Comprar",
  "zh_CN": "购买",
  "zh_TW": "購買"
} );


defineSimpleTerm( "ItemBuyEditor.label.submit",  "Place order",       {
  "ru_RU": "Купить",
  "cs_CZ": "Provést příkaz",
  "fr_FR": "Valider votre commande",
  "de_DE": "Auftrag platzieren",
  "it_IT": "Piazza un ordine",
  "ko_KR": "구매 요청",
  "pl_PL": "Umieść polecenie",
  "pt_PT": "Place order",
  "es_ES": "Realizar pedido",
  "zh_CN": "下单",
  "zh_TW": "下單"
} );


defineSimpleTerm( "ItemBuyEditor.label.price",  "What price do you want to pay (per item):",       {
  "ru_RU": "Цена за единицу",
  "cs_CZ": "Co chcete zaplatit (za předmět):",
  "fr_FR": "Quel prix voulez-vous payer (par item):",
  "de_DE": "Welchen Preis möchtest du zahlen (pro Item):",
  "it_IT": "Prezzo da pagare (per oggetto):",
  "ko_KR": "(개당)원하는 구매가를 입력해 주세요",
  "pl_PL": "Jaką cenę chcesz zapłacić (na jeden przedmiot):",
  "pt_PT": "What price do you want to pay (per item):",
  "es_ES": "Qué precio quieres pagar (por artículo):",
  "zh_CN": "你想支付什么价格（每个物品）：",
  "zh_TW": "你想付多少價格（每個物品）："
} );


defineSimpleTerm( "ItemBuyEditor.label.amount",  "How many do you want to buy:",       {
  "ru_RU": "Сколько вы хотите купить:",
  "cs_CZ": "Kolik jich chcete koupit:",
  "fr_FR": "Combien voulez-vous en acheter:",
  "de_DE": "Wie viele möchtest du kaufen:",
  "it_IT": "Quantitativo da acquistare:",
  "ko_KR": "원하는 구매 수량을 입력해 주세요:",
  "pl_PL": "Ile przedmiotów chcesz kupić:",
  "pt_PT": "How many do you want to buy:",
  "es_ES": "Cuantos quieres comprar:",
  "zh_CN": "你想购买多少数量：",
  "zh_TW": "你想購買多少數量："
} );


defineSimpleTerm( "ItemBuyEditor.label.totalPrice",  "Total price (includes fees) of ",       {
  "ru_RU": "Сумма, включая комиссию, за ",
  "cs_CZ": "Total price (includes fees) of ",
  "fr_FR": "Total price (includes fees) of ",
  "de_DE": "Total price (includes fees) of ",
  "it_IT": "Total price (includes fees) of ",
  "ko_KR": "Total price (includes fees) of ",
  "pl_PL": "Total price (includes fees) of ",
  "pt_PT": "Total price (includes fees) of ",
  "es_ES": "Total price (includes fees) of ",
  "zh_CN": "总价（包含费用）：",
  "zh_TW": "總價（包含費用）："
} );


defineSimpleTerm( "ItemBuyEditor.label.agree",  "I agree to Gaijin Store",       {
  "ru_RU": "Я соглашаюсь с",
  "cs_CZ": "Souhlasím s Gaijin Store",
  "fr_FR": "J'accepte les conditions d'utilisation de la boutique Gaijin",
  "de_DE": "Ich stimme dem Gaijin-Shop zu",
  "it_IT": "Acconsento al Negozio Gaijin",
  "ko_KR": "가이진 스토어 정책에 동의합니다",
  "pl_PL": "Zgadzam się na Gaijin Store",
  "pt_PT": "I agree to Gaijin Store",
  "es_ES": "Estoy de acuerdo con la Tienda Gaijin",
  "zh_CN": "我同意 Gaijin Store",
  "zh_TW": "我同意 Gaijin Store"
} );


defineSimpleTerm( "ItemBuyEditor.label.ToU",  "Terms of Use",       {
  "ru_RU": "Пользовательским соглашением",
  "cs_CZ": "Podmínky užití",
  "fr_FR": "Conditions d'utilisation",
  "de_DE": "Nutzungsbedingungen",
  "it_IT": "Termini di Utilizzo",
  "ko_KR": "이용 약관",
  "pl_PL": "Terms of Use",
  "pt_PT": "Terms of Use",
  "es_ES": "Términos de Uso",
  "zh_CN": "使用条款",
  "zh_TW": "使用條款"
} );

